// Mock data for Window & Door Configurator
import { ralColors, getColorByRAL, getColorById as getColorByIdFromRAL } from './ralColors';
import { KOZIJNEN_MIN_DIMENSION_MM } from '../lib/pdfPricing';

export const windowTypes = [
  {
    id: 'fixed',
    name: 'Fixed Window',
    icon: 'square',
    description: 'Non-opening window'
  },
  {
    id: 'tilt-turn',
    name: 'Tilt & Turn',
    icon: 'flip-horizontal',
    description: 'Versatile opening system'
  },
  {
    id: 'sliding',
    name: 'Sliding Window',
    icon: 'move-horizontal',
    description: 'Horizontal sliding'
  },
  {
    id: 'casement',
    name: 'Casement Window',
    icon: 'door-open',
    description: 'Side-hinged opening'
  },
  {
    id: 'door',
    name: 'Door',
    icon: 'door-closed',
    description: 'Entry door system'
  }
];

// Parts configuration
export const partsOptions = [
  { id: '1', name: '1 Part', value: 1 },
  { id: '2', name: '2 Parts', value: 2 },
  { id: '3', name: '3 Parts', value: 3 },
  { id: '4', name: '4 Parts', value: 4 },
  { id: '5', name: '5 Parts', value: 5 }
];

// Overhead options
export const overheadOptions = [
  { id: 'no-overhead', name: 'No overhead' },
  { id: 'overhead', name: 'Overhead' }
];

// Wood Joint options
export const woodJointOptions = [
  { id: 'joint-45', name: 'Wood Joint 45°' },
  { id: 'joint-90', name: 'Wood Joint 90°' }
];

// Division type
export const divisionTypes = [
  { id: 'equal', name: 'Equal', icon: 'equal' },
  { id: 'divide', name: 'Divide', icon: 'split' }
];

// Raamtype (Window Type) - Extended options with English names
export const raamtypes = [
  { 
    id: 'fixed-sash', 
    name: 'Fixed Sash', 
    description: 'Non-opening window with frame', 
    icon: 'square',
    image: 'https://customer-assets.emergentagent.com/job_windoor-pro/artifacts/oqixjr3g_1vast-1-247x300.png'
  },
  { 
    id: 'fixed-glass', 
    name: 'Fixed Glass', 
    description: 'Non-opening direct glazing', 
    icon: 'square',
    image: 'https://customer-assets.emergentagent.com/job_windoor-pro/artifacts/nf6wgaig_vaste-vleugel-246x300.png'
  },
  { 
    id: 'tilt-turn-left', 
    name: 'Tilt & Turn Left', 
    description: 'Opens left with tilt function', 
    icon: 'arrow-left',
    image: 'https://customer-assets.emergentagent.com/job_windoor-pro/artifacts/cz186d9q_1dkr-unselected-1-246x300.png'
  },
  { 
    id: 'tilt-turn-right', 
    name: 'Tilt & Turn Right', 
    description: 'Opens right with tilt function', 
    icon: 'arrow-right',
    image: 'https://customer-assets.emergentagent.com/job_windoor-pro/artifacts/k7wx8hff_1dkl-unselected-1-246x300.png'
  },
  { 
    id: 'tilt-only', 
    name: 'Tilt Only', 
    description: 'Top-hinged tilt opening', 
    icon: 'chevron-down',
    image: 'https://customer-assets.emergentagent.com/job_windoor-pro/artifacts/dncicw6p_kiep-raam-2.png'
  },
  { 
    id: 'fixed-panel', 
    name: 'Fixed Panel', 
    description: 'Solid fixed panel', 
    icon: 'square',
    // Local artwork placed in public/images/vast-paneel-1-247x300.png
    image: process.env.PUBLIC_URL + '/images/vast-paneel-1-247x300.png'
  }
];

export const profileSystems = [
  {
    id: 'schuco',
    name: 'Schüco',
    description: 'Schüco window system',
    logo: process.env.PUBLIC_URL + '/images/profile-schuco.png',
    color: '#005AA9'
  },
  {
    id: 'synego',
    name: 'Veka',
    description: 'Softline 82 NL',
    logo: process.env.PUBLIC_URL + '/images/profile-veka.png',
    color: '#E30613'
  }
];

export const keralitProfileSystems = [
  {
    id: 'potdeksel-177',
    name: 'Potdeksel 177',
    description: 'Potdeksel 177',
    logo: process.env.PUBLIC_URL + '/images/keralit-potdeksel-177.png',
    color: '#2B2B2B',
  },
  {
    id: 'sponningdeel-143',
    name: 'Sponningdeel 143',
    description: 'Sponningdeel 143',
    logo: process.env.PUBLIC_URL + '/images/keralit-sponningdeel-143.png',
    color: '#2B2B2B',
  },
];

export const normalizeKeralitProfileSystem = (profileSystemId) => {
  if (profileSystemId === 'potdeksel-177' || profileSystemId === 'sponningdeel-143') {
    return profileSystemId;
  }
  return 'potdeksel-177';
};

// Glass Texture
export const glassTextures = [
  {
    id: 'helder-glas',
    name: 'Clear Glass',
    description: 'Clear transparent glass',
    // Local artwork placed in public/images/glass-helder.svg
    image: process.env.PUBLIC_URL + '/images/glass-helder.svg'
  },
  {
    id: 'chinchilla',
    name: 'Chinchilla',
    description: 'Textured glass',
    // Local artwork placed in public/images/glass-chinchilla.svg
    image: process.env.PUBLIC_URL + '/images/glass-chinchilla.svg'
  },
  {
    id: 'satinato',
    name: 'Satinato',
    description: 'Frosted glass',
    // Local artwork placed in public/images/glass-satinato.svg
    image: process.env.PUBLIC_URL + '/images/glass-satinato.svg'
  }
];

// Glazing Type
export const glazingTypes = [
  {
    id: 'double',
    name: 'Double Glass 24 mm (HR++)',
    description: 'High-efficiency double glazing 24mm',
    // Local artwork placed in public/images/hr.png
    image: process.env.PUBLIC_URL + '/images/hr.png'
  },
  {
    id: 'triple',
    name: 'Triple Glass 36 mm (HR++)',
    description: 'High-efficiency triple glazing 36mm',
    // Local artwork placed in public/images/hr-1.png
    image: process.env.PUBLIC_URL + '/images/hr-1.png'
  }
];

// Legacy color IDs mapped to RAL codes for backward compatibility.
// Only kept for default config values; all of these map to an allowed RAL color.
export const colors = [
  { id: 'anthracite', name: 'Anthracite (RAL 7016)', hex: '#293133', ral: '7016' },
  { id: 'black', name: 'Black Woodgrain Ligna (RAL 9005)', hex: '#0A0A0A', ral: '9005' },
  { id: 'white', name: 'White (RAL 9010)', hex: '#FFFFFF', ral: '9010' },
  { id: 'green', name: 'Fir Green (RAL 6009)', hex: '#27352A', ral: '6009' }
];

// Enhanced getColorById that also checks default colors
export const getColorById = (id) => {
  if (!id) return null;
  
  // First check default colors array
  const defaultColor = colors.find(c => c.id === id);
  if (defaultColor) {
    return {
      id: defaultColor.id,
      name: defaultColor.name,
      hex: defaultColor.hex,
      ral: defaultColor.ral,
      category: defaultColor.ral ? (ralColors.find(r => r.ral === defaultColor.ral)?.category || 'grey') : 'grey'
    };
  }
  
  // Then use the RAL color lookup (which handles 'ral-XXXX' format)
  return getColorByIdFromRAL(id);
};

// Re-export other RAL functions
export { ralColors, getColorByRAL };

export const openingTypes = [
  {
    id: 'left',
    name: 'Left Opening',
    icon: 'arrow-left',
    validFor: ['tilt-turn', 'casement', 'door']
  },
  {
    id: 'right',
    name: 'Right Opening',
    icon: 'arrow-right',
    validFor: ['tilt-turn', 'casement', 'door']
  },
  {
    id: 'tilt',
    name: 'Tilt Only',
    icon: 'chevron-down',
    validFor: ['tilt-turn']
  },
  {
    id: 'none',
    name: 'No Opening',
    icon: 'x',
    validFor: ['fixed']
  }
];

export const hardware = [
  {
    id: 'handle-standard',
    name: 'Standard Handle',
    category: 'handle',
    applicableTo: ['tilt-turn', 'casement', 'door']
  },
  {
    id: 'handle-premium',
    name: 'Premium Handle',
    category: 'handle',
    applicableTo: ['tilt-turn', 'casement', 'door']
  },
  {
    id: 'lock-basic',
    name: 'Basic Lock',
    category: 'lock',
    applicableTo: ['door']
  },
  {
    id: 'lock-security',
    name: 'Multi-Point Lock',
    category: 'lock',
    applicableTo: ['door']
  },
  {
    id: 'hinges-standard',
    name: 'Standard Hinges',
    category: 'hinges',
    applicableTo: ['tilt-turn', 'casement', 'door']
  },
  {
    id: 'hinges-concealed',
    name: 'Concealed Hinges',
    category: 'hinges',
    applicableTo: ['door']
  }
];

export const accessories = [
  {
    id: 'mosquito-net',
    name: 'Mosquito Net',
    applicableTo: ['tilt-turn', 'casement', 'sliding']
  },
  {
    id: 'roller-shutter',
    name: 'Roller Shutter',
    applicableTo: ['fixed', 'tilt-turn', 'casement', 'sliding']
  },
  {
    id: 'window-sill',
    name: 'Internal Window Sill',
    applicableTo: ['fixed', 'tilt-turn', 'casement', 'sliding']
  },
  {
    id: 'threshold',
    name: 'Low Threshold',
    applicableTo: ['door']
  },
  {
    id: 'child-safety',
    name: 'Child Safety Lock',
    applicableTo: ['tilt-turn', 'casement']
  },
  {
    id: 'ventilation',
    name: 'Ventilation Grille',
    applicableTo: ['fixed', 'tilt-turn', 'casement']
  }
];

export const DIMENSION_CONSTRAINTS = {
  MIN_WIDTH: KOZIJNEN_MIN_DIMENSION_MM,
  MAX_WIDTH: 6000,
  MIN_HEIGHT: KOZIJNEN_MIN_DIMENSION_MM,
  MAX_HEIGHT: 4000,
  MIN_PART_WIDTH: 200
};

// Pricing structure - base price and option prices
export const PRICING = {
  // Base price per square meter
  BASE_PRICE_PER_SQM: 250,
  
  // Profile system prices (additive to base)
  profileSystem: {
    'synego': 0, // Default, no extra cost
    'synego-1': 0, // Terrace door variant, same price
    'option-2': 30, // Without Stop
    'option-3': 40, // Stop Left, Top and Right (T-profile)
    'schuco': 50,
    'potdeksel-177': 0,
    'sponningdeel-143': 0,
  },
  
  // Glass texture prices (additive to base)
  glassTexture: {
    'helder-glas': 0, // Default, no extra cost
    'clear': 0, // Terrace door variant, same as helder-glas
    'chinchilla': 30,
    'satinato': 40
  },
  
  // Glazing type prices (additive to base)
  glazingType: {
    'double': 0, // Default, no extra cost
    'double-24': 0, // Terrace door variant, same price
    'double-36': 80, // Terrace door variant, same as triple
    'triple': 80
  },
  
  // Color prices (additive to base)
  color: {
    'anthracite': 0, // Default, no extra cost
    'black': 20,
    'white': 0,
    'brown': 25,
    'beige': 15,
    'green': 30,
    'blue': 30,
    'wood': 40
  },
  
  // Interior frame color prices (additive to base)
  interiorFrameColor: {
    'white': 0, // Default, no extra cost
    'anthracite': 20,
    'black': 20,
    'brown': 25,
    'beige': 15,
    'green': 30,
    'blue': 30,
    'wood': 40
  },
  
  // Window type prices per part (additive to base)
  raamtype: {
    'fixed-sash': 0, // Default, no extra cost
    'fixed-glass': 20,
    'tilt-only': 171.28, // Kozijnen: same formula as tilt-turn (add per part)
    'tilt-turn-left': 127.95, // Updated to match actual pricing difference
    'tilt-turn-right': 127.95, // Updated to match actual pricing difference
    'fixed-panel': -30 // Discount for panel
  },
  
  // Parts pricing (multiplier)
  parts: {
    1: 1.0, // Base multiplier
    2: 1.8, // 2 parts = 1.8x base
    3: 2.5,
    4: 3.1,
    5: 3.6
  },
  
  // Overhead pricing (additive per overhead part)
  overhead: {
    'no-overhead': 0,
    'overhead': 100 // Base overhead cost, plus per part
  },
  overheadPart: 50, // Per overhead part
  
  // Wood joint prices (additive to base)
  woodJoint: {
    'joint-45': 0, // Default, no extra cost
    'joint-90': 15
  },
  
  // Hardware prices (additive per item)
  hardware: {
    'handle-standard': 25,
    'handle-premium': 60,
    'lock-basic': 40,
    'lock-security': 120,
    'hinges-standard': 30,
    'hinges-concealed': 80
  },
  
  // Accessories prices (additive per item)
  accessories: {
    'mosquito-net': 45,
    'roller-shutter': 150,
    'window-sill': 35,
    'threshold': 50,
    'child-safety': 25,
    'ventilation': 30
  },
  
  // Size-based pricing adjustments
  sizeMultiplier: {
    // Based on total area in square meters
    small: { max: 2, multiplier: 1.0 }, // 0-2 sqm
    medium: { max: 4, multiplier: 0.95 }, // 2-4 sqm
    large: { max: 8, multiplier: 0.90 }, // 4-8 sqm
    xlarge: { max: Infinity, multiplier: 0.85 } // 8+ sqm
  },
  
  // Terrace Door specific pricing
  terrasdeur: {
    // Design type prices (additive)
    designType: {
      'no-panel': 0, // Default, no extra cost
      'left-panel': 150,
      'right-panel': 150,
      'both-panels': 300
    },
    // Door type prices (additive)
    doorType: {
      'normal': 0, // Default, no extra cost
      'top-light': 200
    },
    // Handle position prices (additive)
    handlePosition: {
      'left': 0, // Default, no extra cost
      'right': 0
    },
    // Threshold height prices (additive)
    thresholdHeight: {
      '30mm': 0, // Default, no extra cost
      '55mm': 40
    },
    // Parapet prices (additive) – main door parapet
    parapet: {
      'no-parapet': 0, // Default, no extra cost
      'with-parapet': 196.49 // 2200×2200 left panel: 3062.59 + 196.49 = 3259.08
    },
    // Side panel parapet (left/right panel settings) – per panel when enabled
    sidePanelParapet: 100.92, // 2200×2200 left panel + left panel parapet: 3062.59 + 100.92 = 3163.51
    // Side panel overhead (left/right panel settings) – per panel when enabled
    sidePanelOverhead: 500,
    // Security bracket prices (additive)
    securityBracket: {
      'none': 0, // Default, no extra cost
      'skg-2': 150
    },
    // Overhead parts pricing (for top-light)
    overheadParts: {
      1: 0, // Base overhead cost included in doorType
      2: 80 // Additional cost for 2 parts
    }
  },
  
  // Back Door (Achterdeur) specific pricing
  achterdeur: {
    // Top Light prices (additive)
    topLight: {
      'no-top-light': 0, // Default, no extra cost
      'with-top-light': 200
    },
    // Number of Parts prices (additive)
    numberOfParts: {
      'one-part': 0, // Default, no extra cost
      'two-parts': 50 // Per lower section (main door + each active side panel)
    },
    // Panel Type prices (additive, only when two-parts is selected)
    panelType: {
      'sandwich-no-mullions': 0, // Default, no extra cost
      'glass': 50,
      'horizontal-mullions': 80,
      'vertical-mullions': 80
    },
    // Handle position prices (additive)
    handlePosition: {
      'left': 0, // Default, no extra cost
      'right': 0
    },
    // Threshold height prices (additive)
    thresholdHeight: {
      '30mm': 0, // Default, no extra cost
      '55mm': 40
    },
    // Parapet prices (additive, when two-parts is selected)
    parapet: {
      'no-parapet': 0, // Default, no extra cost
      'with-parapet': 100
    },
    // Security prices (additive)
    security: {
      'none': 0, // Default, no extra cost
      'skg-2': 150
    },
    // Overhead parts pricing (for top-light)
    overheadParts: {
      1: 0, // Base overhead cost included in topLight
      2: 80 // Additional cost for 2 parts
    }
  },
  
  // Front Door (Voordeur) specific pricing
  // Dimension/panel/top-light bases from data: 1000×2200 no panel no top=1376.08; 1010×2210=1382.52 → rate 0.322/mm
  voordeur: {
    baseWidth: 1000,
    baseHeight: 2200,
    topLightHeightThreshold: 2500,
    ratePerMm: 0.322,
    // Base at 1000×2200 when no top light
    baseNoTopLight: {
      'no-panel': 1376.08,
      'left-panel': 1328.06,
      'right-panel': 1328.06,
      'both-panels': 1524.53
    },
    // Base at 1000×2500 when with top light (height 2200–2500 included in top light)
    baseWithTopLight: {
      'no-panel': 1403.50,
      'left-panel': 1627.09,
      'right-panel': 1627.09,
      'both-panels': 1835.28
    },
    // Door style prices (additive on top of base)
    doorStyle: {
      'style-1': 0, // Default, no extra cost
      'style-2': 50,
      'style-3': 50,
      'style-4': 100,
      'style-5': 100,
      'style-6': 150
    },
    // Parapet/Handle type prices (additive)
    parapet: {
      'standard-knob': 0, // Default, no extra cost
      'rvs-bar': 75 // RVS Bar handle
    },
    // Threshold height prices (additive)
    thresholdHeight: {
      '30mm': 0, // Default, no extra cost
      '55mm': 40
    },
    // Security prices (additive)
    security: {
      'none': 0, // Default, no extra cost
      'extra-security': 150
    },
    // Handle position prices (additive)
    handlePosition: {
      'left': 0, // Default, no extra cost
      'right': 0
    }
  },

  // Sliding door (Schuifpui) — reference values ex-VAT; base prices live in pdfPricing.js
  schuifpui: {
    slidingPosition: {
      left: 6033.06,
      right: 7024.79,
      center: 8264.46,
    },
    baseWidthMm: 2000,
    baseHeightMm: 2000,
    minWidthMm: { left: 2000, right: 3000, center: 4000 },
    minHeightMm: 1800,
    maxHeightMm: 2500,
    dimensionStepMm: 100,
    dimensionStepPrice: 100,
    thresholdHeight: {
      '30mm': 0,
      '55mm': 40,
    },
    ventilatorPricePer100mm: 10,
  },

  // Kozijnen (Windows) – glass and glazing prices (used by Summary/Quote when pageType is kozijnen)
  kozijnen: {
    glassTexture: {
      'helder-glas': 0,
      'chinchilla': 72.39,
      'satinato': 72.39
    },
    glazingType: {
      'double': 0,
      'double-24': 0,
      'double-36': 80,
      'triple': 80
    }
  }
};
